import * as z from "zod";

export const authorizeUspsCarrierAccount = {
  name: "authorizeUspsCarrierAccount" as const,
  input: z.object({
    authorizationCode: z.string(),
    carrierAccountId: z.string(),
  }),
  output: z.object({
    success: z.boolean(),
    failureMessage: z.string().nullish(),
  }),
};
